import { render, staticRenderFns } from "./WsSortItem.vue?vue&type=template&id=f4296fe4&"
import script from "./WsSortItem.vue?vue&type=script&lang=js&"
export * from "./WsSortItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports